export const LOCAL_PAGES = [
  {
    slug: "dj-mariage-drome",
    path: "/dj-mariage-drome",
    title: "DJ Mariage Drôme (26) | KLMProd — Animation musicale haut de gamme",
    description:
      "DJ mariage en Drôme : Valence, Montélimar, Romans-sur-Isère, Suze-la-Rousse… Formules dès 800 €, playlist collaborative, matériel Pioneer DJ, Sennheiser et Yamaha. Devis gratuit sous 48 h.",
    eyebrow: "Drôme · Valence · Montélimar · Suze-la-Rousse",
    h1: "DJ mariage en Drôme",
    h1Accent: "votre soirée, notre métier.",
    intro:
      "Vous vous mariez dans la Drôme ? KLMProd conçoit l'ambiance musicale de votre journée, du vin d'honneur à la dernière danse. Préparation rigoureuse, playlist collaborative, matériel de régie professionnel : votre piste de danse reste pleine jusqu'à 4 H du matin.",
    zones: ["Valence", "Montélimar", "Romans-sur-Isère", "Suze-la-Rousse", "Crest", "Die", "Nyons", "Loriol-sur-Drôme"],
    sections: [
      {
        title: "Une soirée construite avec vous",
        text: "Rendez-vous de préparation, playlist collaborative partagée avec vos proches, titres imposés et titres interdits : votre mariage dans la Drôme ne ressemble à aucun autre. Les demandes sont clôturées 48 h avant le jour J pour garantir des transitions fluides.",
      },
      {
        title: "Sonorisation et éclairage professionnels",
        text: "Sonorisation haute fidélité Yamaha, régie Pioneer DJ, micros sans fil Sennheiser pour vos discours et structures Global Truss. De la mise en lumière de votre salle aux étincelles froides de l'ouverture de bal, chaque détail technique est maîtrisé.",
      },
      {
        title: "Des conditions claires, sans surprise",
        text: "Trois formules transparentes de 800 € à 1 600 €, contrat écrit, signature en ligne et acompte de 30 % payable par carte. Vous savez exactement ce que vous réservez — et jusqu'à quelle heure nous restons : 4 H du matin.",
      },
    ],
    faq: [
      {
        q: "Quel est le tarif d'un DJ mariage dans la Drôme ?",
        a: "Nos formules mariage démarrent à 800 € (Essentielle), 1 200 € (Médium) et 1 600 € (Prestige), présence jusqu'à 4 H du matin incluse. Le déplacement dans la Drôme est inclus dans nos zones d'intervention.",
      },
      {
        q: "Vous déplacez-vous dans tout le département ?",
        a: "Oui : Valence, Montélimar, Romans-sur-Isère, Crest, Nyons, Suze-la-Rousse et les domaines de réception alentour. Pour les communes plus éloignées, le déplacement est chiffré dans votre devis.",
      },
      {
        q: "Peut-on choisir nos musiques ?",
        a: "C'est le principe de notre playlist collaborative : vous et vos invités proposez vos titres via un code d'accès dédié, nous les intégrons à une programmation cohérente et dansante.",
      },
    ],
    img: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=1600&q=80&auto=format&fit=crop",
    cta: "Demander mon devis mariage Drôme",
  },
  {
    slug: "dj-mariage-vaucluse",
    path: "/dj-mariage-vaucluse",
    title: "DJ Mariage Vaucluse (84) haut de gamme | Scénographie sur-mesure — KLMProd",
    description:
      "DJ mariage haut de gamme en Vaucluse : Avignon, Orange, Carpentras, Vaison-la-Romaine… Scénographie lumière sur-mesure, playlist collaborative, matériel premium. Devis sous 48 h.",
    eyebrow: "Vaucluse · Avignon · Orange · Vaison-la-Romaine",
    h1: "DJ mariage haut de gamme",
    h1Accent: "en Vaucluse.",
    intro:
      "Bastides, domaines viticoles, mas provençaux : la Vaucluse offre des cadres exceptionnels, KLMProd leur donne une scénographie à la hauteur. Éclairage architectural sur-mesure, programmation DMX personnalisée et une prestation DJ millimétrée pour votre mariage.",
    zones: ["Avignon", "Orange", "Carpentras", "Vaison-la-Romaine", "L'Isle-sur-la-Sorgue", "Apt", "Cavaillon", "Bollène"],
    sections: [
      {
        title: "Scénographie mariage sur-mesure",
        text: "Mise en lumière de votre salle ou de vos pierres extérieures, fumée lourde pour une première danse dans les nuages, étincelles froides sur la pièce montée : notre formule Prestige transforme votre lieu de réception en véritable scène.",
      },
      {
        title: "Le haut de gamme, c'est d'abord la préparation",
        text: "Rendez-vous de préparation, repérage technique, coordination avec vos témoins et vos prestataires, playlist collaborative : rien n'est laissé au hasard. Le jour J, vous profitez — nous gérons.",
      },
      {
        title: "Une organisation écrite et transparente",
        text: "Devis détaillé, contrat signé en ligne, deux contacts référents pour vos surprises, demandes clôturées 48 h avant. Votre mariage en Vaucluse est cadré de la première note à la dernière.",
      },
    ],
    faq: [
      {
        q: "Qu'apporte la formule Prestige pour un mariage en Vaucluse ?",
        a: "Tout le contenu de la formule Médium, plus les étincelles froides, la machine à fumée lourde (effet nuage) et une programmation lumière DMX personnalisée — idéale pour les domaines et bastides de la Vaucluse.",
      },
      {
        q: "Pouvez-vous sonoriser une cérémonie laïque en extérieur ?",
        a: "Oui, dès la formule Médium : sonorisation du vin d'honneur ou de la cérémonie et micros sans fil Sennheiser haute portée sont inclus.",
      },
      {
        q: "Jusqu'à quelle heure le DJ reste-t-il ?",
        a: "Jusqu'à 4 H du matin, dans les trois formules. Sans supplément horaire caché.",
      },
    ],
    img: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1600&q=80&auto=format&fit=crop",
    cta: "Demander mon devis mariage Vaucluse",
  },
  {
    slug: "soiree-entreprise-drome-ardeche",
    path: "/soiree-entreprise-drome-ardeche",
    title: "DJ Soirée d'entreprise Drôme & Ardèche | Séminaires — KLMProd",
    description:
      "Animation DJ pour soirées d'entreprise et séminaires en Drôme et Ardèche : sonorisation, éclairage, vidéoprojection, micros HF. Devis dédié sous 48 h.",
    eyebrow: "Drôme · Ardèche · Séminaires & soirées d'entreprise",
    h1: "Soirées d'entreprise",
    h1Accent: "en Drôme et Ardèche.",
    intro:
      "Séminaire à Suze-la-Rousse, soirée de fin d'année à Valence, lancement de produit à Privas : KLMProd sonorise et éclaire vos événements professionnels avec le même niveau d'exigence que nos mariages haut de gamme.",
    zones: ["Valence", "Montélimar", "Suze-la-Rousse", "Privas", "Aubenas", "Annonay", "Tournon-sur-Rhône", "Romans-sur-Isère"],
    sections: [
      {
        title: "Une prestation pensée pour les entreprises",
        text: "Discours au micro, vidéoprojection de vos présentations sur écran, fond sonore pendant le dîner puis montée en puissance sur la piste de danse : nous construisons le déroulé avec votre organisateur ou votre comité.",
      },
      {
        title: "Matériel de régie professionnel",
        text: "Sonorisation Yamaha, régie Pioneer DJ, micros sans fil Sennheiser, structures Global Truss et vidéoprojecteur avec écran : vos collaborateurs comme vos dirigeants sont entendus et vus, dans les meilleures conditions.",
      },
      {
        title: "Un interlocuteur unique, un devis clair",
        text: "Chaque événement d'entreprise fait l'objet d'un devis dédié, établi sous 48 h après votre demande. Contrat écrit, acompte de 30 % à la signature, solde payable en ligne : vos services achats apprécieront.",
      },
    ],
    faq: [
      {
        q: "Intervenez-vous pour un séminaire à Suze-la-Rousse ?",
        a: "Oui, le château de Suze-la-Rousse et les autres lieux de séminaire de la Drôme provençale font partie de nos zones d'intervention habituelles.",
      },
      {
        q: "Pouvez-vous gérer la vidéoprojection de nos présentations ?",
        a: "Oui : vidéoprojecteur avec écran disponible, et vos fichiers sont testés en amont — transmettez-les au plus tard 48 h avant l'événement.",
      },
      {
        q: "Quel est le coût d'une soirée d'entreprise ?",
        a: "Nos soirées d'entreprise sont chiffrées sur devis, à partir de nos formules mariage (800 € à 1 600 €) selon la durée, le lieu et les options retenues. Réponse sous 48 h.",
      },
    ],
    img: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1600&q=80&auto=format&fit=crop",
    cta: "Demander un devis entreprise",
  },
  {
    slug: "anniversaire-haut-de-gamme",
    path: "/anniversaire-haut-de-gamme",
    title: "Anniversaire haut de gamme | DJ & scénographie d'exception — KLMProd",
    description:
      "Anniversaire d'exception (30, 40, 50 ans et plus) : DJ, éclairage architectural, étincelles froides et fumée lourde. Prestation haut de gamme en Drôme, Vaucluse et Ardèche. Devis sous 48 h.",
    eyebrow: "Drôme · Vaucluse · Ardèche",
    h1: "Un anniversaire haut de gamme,",
    h1Accent: "pensé comme un show.",
    intro:
      "30, 40, 50 ans ou plus : un grand anniversaire mérite mieux qu'une enceinte bluetooth. KLMProd apporte la régie complète — DJ, lumières architecturales, effets scéniques — pour une soirée dont on parlera encore dans dix ans.",
    zones: ["Drôme", "Vaucluse", "Ardèche", "Valence", "Montélimar", "Avignon", "Orange", "Privas"],
    sections: [
      {
        title: "Vos classiques, notre programmation",
        text: "Grâce à la playlist collaborative, vos invités proposent leurs titres avant la soirée — des tubes de vos vingt ans aux nouveautés du moment. Nous orchestrons le tout avec des transitions propres, jusqu'à 4 H du matin.",
      },
      {
        title: "Des effets dignes d'une scène",
        text: "Étincelles froides pour l'entrée du gâteau, fumée lourde pour un slow dans les nuages, mise en lumière LED de votre salle ou de votre jardin : les effets de nos formules mariage subliment aussi vos anniversaires.",
      },
      {
        title: "Simple à organiser",
        text: "Un rendez-vous de préparation, une playlist partagée, un devis écrit et un acompte en ligne : l'organisation prend moins d'une heure de votre côté. Le reste est entre nos mains.",
      },
    ],
    faq: [
      {
        q: "Quel budget prévoir pour un anniversaire haut de gamme ?",
        a: "Nos prestations démarrent à 800 € (formule Essentielle). Les effets scéniques comme les étincelles froides ou la fumée lourde sont disponibles en formule Prestige ou en option sur devis.",
      },
      {
        q: "Intervenez-vous dans une propriété privée ou un jardin ?",
        a: "Oui, en intérieur comme en extérieur. Nous recommandons la souscription d'une assurance intempéries pour les réceptions en plein air.",
      },
      {
        q: "Nos invités peuvent-ils proposer des chansons ?",
        a: "Oui, via notre playlist collaborative et son code d'accès dédié. Les demandes se clôturent 48 h avant la soirée pour garantir une programmation fluide.",
      },
    ],
    img: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1600&q=80&auto=format&fit=crop",
    cta: "Demander un devis anniversaire",
  },
];
